(function () {
  const initFeaturedCollection = () => {
    document.querySelectorAll('.featured-collection[data-carousel="true"]').forEach((section) => {
      const swiperEl = section.querySelector('.js-featured-collection-swiper');
      const prevBtn = section.querySelector('.js-featured-collection-prev');
      const nextBtn = section.querySelector('.js-featured-collection-next');

      if (!swiperEl) return;

      const columnsMobile = parseInt(section.dataset.columnsMobile) || 1;
      const columnsDesktop = parseInt(section.dataset.columnsDesktop) || 3;

      new Swiper(swiperEl, {
        slidesPerView: columnsMobile,
        spaceBetween: 16,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
        },
        breakpoints: {
          750: {
            slidesPerView: Math.min(columnsDesktop, 2),
            spaceBetween: 16,
          },
          990: {
            slidesPerView: columnsDesktop,
            spaceBetween: 16,
          },
        },
      });
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    initFeaturedCollection();
    document.addEventListener('shopify:section:load', function () {
      initFeaturedCollection();
    });
  });
})();
